import type { ChatSessionsAttributes } from 'core_main/api/sessions/types';
import { getStore } from 'core_main/store';

import { normalizeSessionCustomAttributes } from './chat_history_status_filter';
import type { ConversationCallbackResponse } from './types';

type ConversationAttributeSlice = Pick<
  ConversationCallbackResponse,
  | 'name'
  | 'preview'
  | 'lastMessageAt'
  | 'lastResponder'
  | 'previewDetailsName'
  | 'custom'
>;

/**
 * Maps session `attributes` into the overlapping `ConversationCallbackResponse` fields
 * used by both create-session and get-single-session flows (legacy preview flag, name,
 * preview, last message, previewDetails).
 */
export const conversationCallbackFieldsFromSessionAttributes = (
  attributes: ChatSessionsAttributes,
): Partial<ConversationAttributeSlice> => {
  const { name, preview, lastMessageAt, previewDetails } = attributes;
  const useLegacy = getStore().useLegacyConversationPreview;
  const nameTrimmed = (name ?? '').trim();
  const resolvedName = useLegacy ? undefined : nameTrimmed || undefined;
  const previewDetailsName = previewDetails?.name?.trim() || undefined;
  const custom = normalizeSessionCustomAttributes(attributes.custom);

  return {
    ...(resolvedName !== undefined ? { name: resolvedName } : {}),
    ...(preview !== undefined ? { preview } : {}),
    ...(lastMessageAt !== undefined ? { lastMessageAt } : {}),
    ...(previewDetails?.lastResponder
      ? { lastResponder: previewDetails.lastResponder }
      : {}),
    ...(previewDetailsName ? { previewDetailsName } : {}),
    ...(custom ? { custom } : {}),
  };
};
